export const getMs = (minutes: number, seconds: number): number => minutes * 60000 + seconds * 1000
